export const isBrandPCLocs = (): boolean => {
  const rootDomain: string[] = window.location.hostname.split('.');
  return !!rootDomain.find((v) => v === 'pclocs');
};

export const brandName = (): 'PC Locs' | 'LocknCharge' => {
  return isBrandPCLocs() ? 'PC Locs' : 'LocknCharge';
};
